<script lang="ts">
    import logo from 'src/components/main/about/components/text/logo.svg'
    import topLeft from 'src/components/main/about/components/text/top-left.svg'
    import bottomRight from 'src/components/main/about/components/text/bottom-right.svg'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import background from 'src/components/main/about/components/text/background.svg'
</script>

<section class="text-section" style="--background:url({background})">
    <div class="container">
        <div class="text-wrapper" style="
            --topLeft: url({topLeft});
            --bottomRight: url({bottomRight});
        ">
            <img src="{logo}" class="logo" alt="">
            <div class="intro-title">Find out more about us</div>
            <div class="description">Realis is a bridge between Web 2 users and all the advantages of Web 3 world.</div>
            <a href="https://docs.realis.network/" target="_blank" class="big-btn">Litepaper<img src="{learnMore}"></a>
        </div>
    </div>
</section>

<style lang="postcss">
    .text-section {
        margin: 300px 0;
        position: relative;
    }

    .text-section:before {
        content: "";
        background: var(--background) no-repeat;
        position: absolute;
        z-index: 2;
        left: 0;
        right: 0;
        top: -740px;
        width: 100%;
        height: 2120px;
        background-size: 100%;
    }

    .text-wrapper {
        background: rgba(23, 30, 34, 0.6);
        border: 1px solid #4f4fb8;
        border-radius: 15px;
        height: 650px;
        position: relative;
        -webkit-backdrop-filter: blur(4px);
        backdrop-filter: blur(4px);
        z-index: 3;
    }

    .text-wrapper:before {
        display: block;
        content: '';
        background: var(--topLeft) no-repeat;
        position: absolute;
        width: 182px;
        height: 99px;
        top: -4px;
        left: -4px;
        z-index: 2;
    }

    .text-wrapper:after {
        display: block;
        content: '';
        background: var(--bottomRight) no-repeat;
        position: absolute;
        width: 179px;
        height: 101px;
        bottom: -4px;
        right: -6px;
        z-index: 2;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-weight: 400;
        color: white;
        margin: 250px auto 30px;
        line-height: 1.5;
        letter-spacing: 2px;
        position: relative;
        text-align: center;
    }

    .description {
        color: white;
        font-size: 20px;
        max-width: 612px;
        line-height: 1.5;
        text-align: center;
        margin: 0 auto 50px;
    }

    .big-btn {
        min-width: 200px;
        text-align: center;
        text-transform: none !important;
        font-size: 16px !important;
        margin: 0 auto;
        position: relative;
        z-index: 2;
    }

    .logo {
        position: absolute;
        margin: 0 auto;
        left: 50%;
        transform: translate(-50%, 0);
    }

    @media(max-width: 1400px) {
        .text-section {
            margin: 250px 0;
        }

        .text-section:before {
            top: -600px;
        }
    }

    @media(max-width: 1199px) {
        .text-section {
            margin: 200px 0;
        }

        .intro-title {
            font-size: 50px;
        }

        .description {
            font-size: 18px;
        }

        .text-section:before {
            top: -550px;
            height: 1000px;
        }

        .text-wrapper {
            height: 610px;
        }
    }

    @media(max-width: 991px) {
        .logo {
            width: 100%;
        }

        .text-section {
            margin: 150px 0;
        }

        .text-section:before {
            top: -360px;
            height: 600px;
        }
    }

    @media(max-width: 767px) {
        .text-section {
            margin: 100px 0 150px;
        }

        .text-section:before {
            top: -360px;
            height: 600px;
            background-size: 400%;
            background-position: -350px 30px;
        }

        .text-wrapper {
            overflow: hidden;
            height: auto;
            padding-bottom: 50px;
            border-radius: 17px;
            position: relative;
            z-index: 3;
        }

        .logo {
            width: 140%;
        }

        .intro-title {
            font-size: 30px;
            margin: 190px auto 20px;
            padding: 0 12px;
            z-index: 2;
        }

        .description {
            font-size: 15px;
            margin: 20px 0 40px;
            padding: 0 12px;
        }

        .big-btn {
            z-index: 3;
        }

        .text-wrapper:before {
            top: -1px;
            left: -1px;
        }

        .text-wrapper:after {
            bottom: -1px;
            right: -3px;
        }
    }
</style>
